import {IgenomicsAction} from "@ispm/core/interfaces/genomics-action.interface";
import * as immutable from "immutable";
import {
   IitemsState, ItypeTreeList
} from "@ispm-client/modules/selection-item/interfaces/floatingPanel.interface";
import {ITEM_ACTIONS} from "@ispm-client/modules/selection-item/store/actions";

const initItemsState: IitemsState  = {
  treeItemsList: immutable.Map<string, ItypeTreeList>()
}

export function itemReducer(state: IitemsState = initItemsState, action: IgenomicsAction<any>):IitemsState {
  let newState;
  switch(action.type) {
    case ITEM_ACTIONS.ADD_ITEMS:
      newState = Object.assign({ }, state);
      newState.treeItemsList = newState.treeItemsList.set(action.payload.treeItemList.keys().next().value, action.payload.treeItemList.get(action.payload.treeItemList.keys().next().value));
      return newState;
    default:
      return state;
  }
}
